import { FormControl, FormLabel, Checkbox, Stack, } from '@chakra-ui/react';
import React from 'react';
import FormFieldErrors from '../FormFieldErrors/FormFieldErrors';
import { useTokens } from '../../../context/TokenProvider';
const StandardFormCheckboxGroup = ({ label, name, options, value, error, onChange, ...rest }) => {
    const tokens = useTokens();
    const handleToggle = (id) => {
        if (value.includes(id)) {
            onChange(value.filter((v) => v !== id));
        }
        else {
            onChange([...value, id]);
        }
    };
    return (React.createElement(FormControl, { isInvalid: !!error },
        React.createElement(FormLabel, { "data-testid": "standard_form_checkbox_group__label" }, label),
        React.createElement(Stack, { spacing: tokens.Spacing05 }, options.map((option) => (React.createElement(Checkbox, { "data-testid": "standard_form_checkbox_group__checkbox", key: option.id, name: name, isChecked: value.includes(option.id), onChange: () => handleToggle(option.id), variant: "primary", ...rest }, option.name)))),
        React.createElement(FormFieldErrors, { errors: error })));
};
export default StandardFormCheckboxGroup;
